import Lightbox from "yet-another-react-lightbox";
import { Thumbnails, Counter, Zoom } from "yet-another-react-lightbox/plugins";
import {
  MdClose,
  MdOutlineSaveAlt,
  MdPictureAsPdf,
  MdOutlineNavigateBefore,
  MdOutlineNavigateNext,
} from "react-icons/md";
import clsx from "clsx";
import LoadingWithText from "src/components/LoadingWithText/LoadingWithText";
import TransactionPdfSlide from "./TransactionPdfSlide";
import useDarkMode from "src/hooks/useDarkMode";
import { ICON_SIZES } from "src/helpers/constants";
import React from "react";
import useMobile from "src/hooks/useMobile";
import useCollapsibles from "src/hooks/useCollapsibles";

interface TransactionAttachmentsLightboxProps {
  slides: any[];
  index: number;
  onClose: () => void;
  setIndex: (i: number) => void;
  thumbnailsRef: any;
  unifiedAttachmentsList: any[];
}

const TransactionAttachmentsLightbox: React.FC<
  TransactionAttachmentsLightboxProps
> = ({
  slides,
  index,
  onClose,
  setIndex,
  unifiedAttachmentsList,
  thumbnailsRef,
}) => {
  const { isEnabled: isDarkMode } = useDarkMode();
  const { isMobile } = useMobile();
  const { updateCollapsible, collapsiblePreferences } = useCollapsibles();

  return (
    <Lightbox
      on={{
        view: ({ index }) => {
          setIndex(index);
        },
        exiting: () => {
          updateCollapsible({
            lightboxThumbnailsOpen: !!thumbnailsRef.current?.visible,
          });
        },
      }}
      slides={slides}
      plugins={[Thumbnails, Counter, Zoom]}
      toolbar={{
        buttons: ["close"],
      }}
      index={index}
      open
      close={onClose}
      render={{
        iconClose: () => (
          <MdClose size={!isMobile ? ICON_SIZES.MD_LG : ICON_SIZES.MD_LG} />
        ),
        iconPrev: () => (
          <MdOutlineNavigateBefore
            size={!isMobile ? ICON_SIZES.XL : ICON_SIZES.LG}
          />
        ),
        iconNext: () => (
          <MdOutlineNavigateNext
            size={!isMobile ? ICON_SIZES.XL : ICON_SIZES.LG}
          />
        ),
        iconLoading: () => <LoadingWithText />,
        iconDownload: () => (
          <MdOutlineSaveAlt size={!isMobile ? ICON_SIZES.MD : ICON_SIZES.MD} />
        ),
        slide: ({ slide }) => {
          return slide?.type === undefined ? (
            <TransactionPdfSlide url={slide?.src} />
          ) : undefined;
        },
        buttonZoom: () => null,
        thumbnail: ({ slide }) => {
          if (slide.type === undefined) {
            return (
              <div
                className={clsx([
                  "flex",
                  "justify-center",
                  "items-center",
                  "w-full",
                  "bg-white",
                  "dark:bg-black",
                  "h-full",
                ])}
              >
                <MdPictureAsPdf
                  size={ICON_SIZES.MD_LG}
                  className={clsx(["text-blue-800", "dark:text-purple-400"])}
                />
              </div>
            );
          }

          // fallback a imagen por default
          return (
            <img
              src={(slide as any).src}
              alt="Imagen"
              className={clsx([
                "object-cover",
                "rounded-md",
                "h-full",
                "w-full",
              ])}
            />
          );
        },
        // ...(isMobile ? { buttonNext: () => null } : {}),
        // ...(isMobile ? { buttonPrev: () => null } : {}),
      }}
      thumbnails={{
        gap: 6,
        borderRadius: 6,
        border: 0,
        borderColor: "#cccccc",
        imageFit: "cover",
        showToggle: true,
        padding: 0,
        hidden: !collapsiblePreferences?.lightboxThumbnailsOpen,
        ref: thumbnailsRef,
        position: isMobile ? "bottom" : "bottom",
        vignette: false,
      }}
      carousel={{ finite: false }}
      styles={{
        root: {
          "--yarl__color_backdrop": "rgba(0,0,0,0.9)",
        },
      }}
      controller={{
        closeOnPullUp: false,
        closeOnPullDown: false,
      }}
    />
  );
};

export default React.memo(TransactionAttachmentsLightbox);
